var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8464 9.59493C22.6423 9.39081 22.311 9.39081 22.1071 9.59493L20.8724 10.8296C20.5728 6.77287 17.6977 3.36909 13.7482 2.39521C9.79884 1.42114 5.67088 3.09814 3.51939 6.55036C3.41848 6.70872 3.41024 6.9092 3.49794 7.07541C3.58564 7.24161 3.75568 7.34808 3.94352 7.35401C4.13136 7.36014 4.3081 7.26478 4.40614 7.10451C6.3043 4.05938 9.93441 2.56525 13.4261 3.39206C16.9179 4.21888 19.4926 7.18187 19.8239 10.7549L18.6633 9.59493C18.4582 9.39693 18.1321 9.39961 17.9303 9.60144C17.7287 9.80307 17.7258 10.1292 17.924 10.3344L20.0155 12.4258C20.2197 12.6301 20.5507 12.6301 20.7549 12.4258L22.8464 10.3344C23.0507 10.1303 23.0507 9.79905 22.8464 9.59493Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3084 15.7927C19.0635 15.6401 18.7411 15.7144 18.5875 15.9587C16.6894 19.0042 13.0592 20.4983 9.56719 19.6715C6.07533 18.8447 3.50066 15.8815 3.16959 12.3083L4.32978 13.4685C4.53486 13.6665 4.86095 13.6638 5.06277 13.462C5.2644 13.2603 5.26728 12.9342 5.06909 12.729L2.97754 10.6376C2.77342 10.4333 2.44235 10.4333 2.23823 10.6376L0.146862 12.729C-0.0513221 12.9342 -0.0486413 13.2603 0.15318 13.462C0.354811 13.6638 0.680904 13.6665 0.886173 13.4685L2.12066 12.2338C2.42052 16.2905 5.29542 19.6943 9.24493 20.6682C13.1944 21.6423 17.3222 19.9655 19.4737 16.513C19.6265 16.2685 19.5526 15.9462 19.3084 15.7927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.a1c40a8683f9c52b65f359bae4439501.svg";
export { ForwardRef as ReactComponent };